import React from "react";
import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";
import { Button } from "@/shared/components/ui/button";
import { Badge } from "@/shared/components/ui/badge";
import { Plus, X } from "lucide-react";

const ApiConfig = ({ formData, handleChange, t, newIp, setNewIp, addIp, removeIp }) => {
  return (
    <div className="space-y-4 mt-4">
      <div className="space-y-2">
        <Label>{t("apiEndpoint")}</Label>
        <Input
          value={formData.api_endpoint}
          onChange={(e) => handleChange("api_endpoint", e.target.value)}
          placeholder={t("apiEndpointPlaceholder")}
        />
      </div>

      <div className="space-y-2">
        <Label>{t("apiKey")}</Label>
        <Input
          value={formData.api_key}
          onChange={(e) => handleChange("api_key", e.target.value)}
          type="password"
        />
      </div>

      <div className="space-y-2">
        <Label>{t("apiSecret")}</Label>
        <Input
          value={formData.api_secret}
          onChange={(e) => handleChange("api_secret", e.target.value)}
          type="password"
        />
      </div>

      <div className="space-y-2">
        <Label>{t("webhookSecret")}</Label>
        <Input
          value={formData.webhook_secret}
          onChange={(e) => handleChange("webhook_secret", e.target.value)}
          type="password"
        />
      </div>

      <div className="space-y-2">
        <Label>{t("providerIpWhitelist")}</Label>
        <div className="flex gap-2">
          <Input
            value={newIp}
            onChange={(e) => setNewIp(e.target.value)}
            placeholder={t("ipWhitelistPlaceholder")}
          />
          <Button onClick={addIp}>
            <Plus className="h-4 w-4" />
          </Button>
        </div>
        <div className="flex flex-wrap gap-2 mt-2">
          {formData.ip_whitelist?.map((ip) => (
            <Badge key={ip} variant="secondary" className="gap-1">
              {ip}
              <button onClick={() => removeIp(ip)}>
                <X className="h-3 w-3" />
              </button>
            </Badge>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ApiConfig;
